module.exports = __webpack_public_path__ + "img/symbol_12.ccc01741.png";